import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import styles from './Wrapper.module.css'
import { isArticleRoute, isCategoryRoute } from '../../../utilities/urls'

const Wrapper = ({ routeName, category, content, children }) => {
  const [ background, setBackground ] = useState(null)

  useEffect(() => {
    if (isArticleRoute(routeName) && content) {
      if (content.background) {
        setBackground(content.background)

        return
      }

      const categoryBackgroundOnArticle = content.category.isBackgroundOnArticles ?? false
      const articleDisabledCategoryBackground = content.disabledBackground ?? false
      const allowedOnArticle = categoryBackgroundOnArticle && !articleDisabledCategoryBackground

      if (allowedOnArticle && content.category?.background) {
        setBackground(content.category.background)

        return
      }

      setBackground(null)
    }

    if (isCategoryRoute && category?.background) {
      setBackground(category.background)
    } else {
      setBackground(null)
    }
  }, [routeName, content, category])

  return (
    <div
      id="navigation-content"
      className={ `${styles.wrapper} ${background ? styles.background : ''}` }
      role="main"
      style={ background ? { '--background-url': `url(${background.href})` } : undefined }
    >
      { children }
    </div>
  )
}

Wrapper.propTypes = {
  routeName: PropTypes.string.isRequired,
  category: PropTypes.object,
  content: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.node.isRequired,
    PropTypes.arrayOf(
      PropTypes.node.isRequired,
    ),
  ]),
}

export default Wrapper
